import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import { FormattedMessage } from 'component-utilities/intl';
import styles from './Login.scss';

/* eslint-disable react/jsx-no-target-blank */
export default function LoginFooter({ copyrightText, termsAndConditionsLink }) {
    return (
        <footer className={styles['login-footer']} data-section="login-footer">
            <span className={styles.copyright}>
                {copyrightText}
            </span>
            {termsAndConditionsLink && (
                <a
                    className={styles['text-link']}
                    href={termsAndConditionsLink}
                    data-action="terms-and-conditions"
                    target="_blank"
                >
          &nbsp;
                    <FormattedMessage id="components.login.terms_and_conditions" />
                </a>
            )}
        </footer>
    );
}
/* eslint-enable react/jsx-no-target-blank */

LoginFooter.displayName = displayName('Login/LoginFooter');

LoginFooter.propTypes = {
    copyrightText: PropTypes.any.isRequired,
    termsAndConditionsLink: PropTypes.string,
};

LoginFooter.defaultProps = {
    termsAndConditionsLink: null,
};
